import React, { useState, useEffect, useRef } from 'react';
// import { Swiper, SwiperSlide } from 'swiper/react';
// import 'swiper/swiper.scss';
import { useSwipeable } from 'react-swipeable';
import Typewriter from 'typewriter-effect';
// import { Element } from 'react-scroll';

import classes from './Home.module.scss';

// import bgSvg from '../../assets/images/bg-discover.svg';
import img1 from '../../assets/images/profile-1.png';
import img1Hover from '../../assets/images/profile-1-hover.png';
import ScrollInfo from '../UI/ScrollInfo/ScrollInfo';
import lnSvg from '../../assets/images/linkedin.svg';
import instaSvg from '../../assets/images/insta.svg';

const typewrightTexts = {
  text1: 'I am a  ',
  text2: ['Filmmaker and Internet entrepreneur'],
  text3: 'Based in Chennai and Singapore.',
  text4: ['Let\'s collaborate!', 'Scroll down for more.'],
  text5: 'just scroll \(｡◕‿◕｡\)\ dun be shy.',
  text6: '...',
  text7: 'omg! intruder alert?! \(｡ʘᗩʘ｡\)\ '
};

const Home = ({ maskSize, setMaskSize, isMobile, ratio  }) => {
  // const maskMinSize = window.innerWidth * 0.06;
  const maskMinSize = Math.max(window.innerWidth * 0.06 * ratio, 80 * ratio);
  const maskMaxSize = Math.min(window.innerWidth * 0.3, 400);

  const [transX, setTransX] = useState(0);
  const [mousePos, setMousePos] = useState([0, 0]);
  const [scrollP, setScrollP] = useState(0);
  const [btnHover, setBtnHover] = useState(false);
  const sideTextsRef = useRef();
  const swipeHandler = useSwipeable({
    onSwipedLeft: ()=> moveContents(),
    onSwipedRight: ()=> moveContents()
  });

  const btnClasses = [classes.Button, 'btn', btnHover ? 'hover' : ''];

  useEffect(()=> {
    let moveTimeout = true;
    const mouseMoveHandler = (e)=> {
      if (moveTimeout) {
        const x = e.pageX;
        const y = e.pageY;
        setMousePos([x, y]);
        moveTimeout = false;
        setTimeout(()=> moveTimeout = true, 100);
      }
    }
    const scrollHandler = ()=> {
      if (window.pageYOffset <= window.innerHeight) {
        // const minTransY = 0, maxTransY = 200;
        const bgY1 = 0;
        const bgY2 = window.innerHeight;
        const bgYP = (window.pageYOffset - bgY1) / (bgY2 - bgY1);
        // const bgTransY = (maxTransY - minTransY) * bgYP / 100;
        setScrollP(bgYP);
        // console.log('bgYP', bgYP);
      }
    }

    document.documentElement.addEventListener('mousemove', mouseMoveHandler);
    window.addEventListener('scroll', scrollHandler);

    return ()=> {
      document.documentElement.removeEventListener('mousemove', mouseMoveHandler);
      window.removeEventListener('scroll', scrollHandler);
    } 
  }, []);

  useEffect(()=> {
    if (transX > 50) {
      document.body.classList.add('scrollable');
      document.body.style = 'overflow: hidden';
    } 
    else {
      document.body.classList.remove('scrollable');
      document.body.style = 'overflow: auto';
    } 
  }, [transX]);

  const cssProp = { "--extraY": `${(100 * scrollP)}%` };

  const moveContents = ()=> {
    if (sideTextsRef.current) {

      const w = sideTextsRef.current.getBoundingClientRect().width;
      setTransX(tx => tx === 0 ? w : 0);
    }
  };

  const typewrighteElements = (
    <div className={classes.TypewriterDiv} style={{
      transform: `translateX(calc(-50% - ${transX}px))`
    }}>
        <Typewriter
          onInit={(typewriter) => {
            typewriter.typeString(`<p>${typewrightTexts.text1}</p> `)
              .typeString(`<p>${typewrightTexts.text2[0]}</p>`)
              .pauseFor(100)
              .deleteAll()
              .typeString(`<p>${typewrightTexts.text3}</p><br>`)
              .typeString(`<p>${typewrightTexts.text4[0]}</p>`)
			  .deleteAll()
			  .typeString(`<p>${typewrightTexts.text4[1]}</p>`)
			  .deleteAll()
              .pauseFor(3000)
				  .typeString(`<p>${typewrightTexts.text5}</p>`)
			  .pauseFor(400)
				  .deleteAll()
			  .typeString(`<p>${typewrightTexts.text6}</p>`)
			  .pauseFor(2000)
				.deleteAll()  
			  .typeString(`<p>${typewrightTexts.text7}</p>`)
			  .pauseFor(1000)
              .start();
          }}
          options={{
            loop: true,
            cursorClassName: classes.Cursor
          }}
        />
    </div>
  );
  
  const sideTextLinkProps = {
    className: 'default',
    onMouseEnter: ()=> setMaskSize(32),
    onMouseLeave: ()=> setMaskSize(16)
  }
  const sideTexts = (
    <div className={[classes.SideTexts, 'scrollable', 'scroll-bar'].join(' ')}  ref={sideTextsRef}
      style={{ transform: `translateX(-${transX}px)`, "--extraY": (100 * scrollP) }}
      onMouseEnter={()=> {
        setMaskSize(16);
        // document.body.style = 'overflow: hidden';
      }}
      onMouseLeave={()=> {
        setMaskSize(maskMinSize);
        // document.body.style = 'overflow: hidden';
      }}
    >
      <p className={classes.Text}><span>F</span>rom a very young age technology called out to me. From coding at the age of 12 and creating a duplicate of my favourite game to becoming a game tester and strategy planner at a leading tech company Nexon.</p>

      <p className={classes.Text}>I finally embraced the nerd in me, and that's how my story began. I think learning is beautiful; if we can all give a little bit of ourselves to others, we will receive much more back. So it wasn't difficult for me to work in a team, learn and then grow to create my very own software and film making platform. When it comes to my journey as a creative, software was my first love. 
      When I'm not designing a graphic or website content with user experience at the forefront of my mind, I am brainstorming ideas for blockbusting films that have gone ahead to rank in the Kollywood industry.</p>

      <p className={classes.Text}>A moment in time can change a person's life forever, my love for capturing moments both as a man with the camera sometimes and a techie combined to produce an app called <a href="#" {...sideTextLinkProps}>Snaplark</a>. Screenshot and GIF recording software that is continuously growing beyond me.</p>

      <p className={classes.Text}>Fast forward 2016, in between creating a screenshot software, I decided to collaborate and create a network, <a href="#" {...sideTextLinkProps}>Fanolly network</a> that has a massive database of cinema industry based articles, where we have our production platform and make our movies.
      In the year 2017, when I was in the army, yes I was! I established <a href="#" {...sideTextLinkProps}>Sumofame</a>. In the space of months, there were more than 1000 orders fulfilled every month. I went on to Promote movies and music videos that even became blockbusters in the youtube and theatres of Kollywood and Bollywood. Managing multiple ventures was a boost for my high-end multitasking abilities.</p>
	  
	  
      <p className={classes.Text}>There is always a story to express about working with people who are passionate about what they do; my story is no different. I enjoy what I do, and it reflects in my work.
      My journey is simple; I grew from being a software creator to an internet entrepreneur to a film-maker.</p>

      <p className={classes.Text}>I'm just guy who has found love in creating, and that's what I intend to do with my life; create!</p>
    </div>
  );

  return (
    <div className={classes.Home}
      {...swipeHandler}
    >

      {/* { isMobile &&
        <Swiper
          className={classes.Swiper}
          onSlideChange={moveContents}
        >
          <SwiperSlide></SwiperSlide>
          <SwiperSlide></SwiperSlide>
        </Swiper>
      } */}
      <div className={classes.Socials} style={{
        transform: `translateX(calc(-50% - ${transX}px))`
      }}>

        <a href="https://www.linkedin.com/in/iamakashsekar/" target="_blank" rel="noopener noreferrer" className={classes.Link}>
          <img src={lnSvg} alt="" style={{ filter: 'invert(0)' }}/>
        </a>

        <a href="https://www.instagram.com/iamakashsekar/" target="_blank" rel="noopener noreferrer" className={classes.Link}>
          <img src={instaSvg} alt="" style={{ filter: 'invert(0)' }} />
        </a>

      </div>

      {typewrighteElements}

        {/* <ScrollInfo small={isMobile} color="#090909">Scroll down</ScrollInfo> */}
        
      {/* { !isMobile &&
      } */}

      { !isMobile &&

        <div className={classes.Mask} style={{
          clipPath: `circle(${maskSize}px at ${mousePos[0]}px ${mousePos[1]}px)`
        }}>

          <div className={classes.Contents} 
            style={{ transform: `translateX(-${transX}px)`, "--extraY": (100 * scrollP) }}
          >
          <div className={classes.CenterNames}>
        <h1 className={classes.NameText}>Akash</h1>
        <h1 className={classes.NameText}>Sekar</h1>
      </div>

            <div className={classes.Center}
              // onMouseEnter={()=> setMaskSize(maskMaxSize)}
              // onMouseLeave={()=> setMaskSize(maskMinSize)}
            >
              <h1 className={[classes.Name1, classes.Name].join(' ')}
                // style={{ transform: `translate(-5%, ${-30 + (100 * scrollP)}%)` }}
                style={cssProp}
              >Akash</h1>
              <h1 className={[classes.Name2, classes.Name].join(' ')}
                // style={{ transform: `translate(10%, ${100 - (100 * scrollP)}%)` }}
                style={cssProp}
              >Sekar</h1>

              <img src={img1Hover} className={classes.Image} alt="IMG"
              />

              {/* <div className={classes.TextContents}> */}
              {/* <div className={classes.TextDiv}>
              </div> */}


              {/* <div className={classes.Socials}>

                <a href="https://www.linkedin.com/" className={classes.Link}>
                  <img src={lnSvg} alt="" style={{ filter: 'invert(1)' }}/>
                </a>

                <a href="https://www.linkedin.com/" className={classes.Link}>
                  <img src={instaSvg} alt="" style={{ filter: 'invert(1)' }} />
                </a>

              </div> */}
              {/* </div> */}
              {/* {typewrighteElements} */}
            </div>

            <button className={btnClasses.join(' ')} onClick={moveContents}
              onMouseEnter={()=> {
                setMaskSize(maskMaxSize * 0.6);
                setBtnHover(true);
              }}
              onMouseLeave={()=> {
                setMaskSize(maskMinSize);
                setBtnHover(false)
              }}
            >
              <p className={classes.Text}>Turn page to know more</p>
              <div className={classes.Arrow}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10.16 16.36"
                  style={{ transform: `rotate3d(0, 1, 0, ${transX === 0 ? 0 : -180}deg)` }}
                >
                  <g id="Layer_2" data-name="Layer 2">
                    <g id="Layer_1-2" data-name="Layer 1">
                      <polygon points="1.36 16.36 0 14.89 7.22 8.18 0 1.46 1.36 0 10.16 8.18 1.36 16.36"/>
                    </g>
                  </g>
                </svg>
              </div>
            </button>

            {/* {sideTexts} */}

          </div>

        </div>
      }

      <div className={classes.Contents} style={{ transform: `translateX(-${transX}px)`, "--extraY": (100 * scrollP) }}>
      <div className={classes.CenterNames}>
        <h1 className={classes.NameText}>Akash</h1>
        <h1 className={classes.NameText}>Sekar</h1>
      </div>

        <div className={classes.Center}>
          <h1 className={[classes.Name1, classes.Name].join(' ')}
            // style={{ transform: `translate(-5%, ${-30 + (100 * scrollP)}%)` }}
            style={cssProp}
          >Akash</h1>
          <h1 className={[classes.Name2, classes.Name].join(' ')}
            // style={{ transform: `translate(10%, ${100 - (100 * scrollP)}%)` }}
            style={cssProp}
          >Sekar</h1>

          <img src={img1} className={classes.Image} alt="IMG"/>

          {/* <div className={classes.TextContents}> */}
            {/* <div className={classes.TextDiv}>
            </div> */}
           

            {/* <div className={classes.Socials}>
              
              <a href="/" className={classes.Link}>
                <img src={lnSvg} alt="" />
              </a>

              <a href="/" className={classes.Link}>
                <img src={instaSvg} alt="" />
              </a>

            </div> */}
          {/* </div> */}
          {/* {typewrighteElements} */}
        </div>

        <button className={btnClasses.join(' ')} onClick={moveContents}>
          <p className={classes.Text}>Turn page to know more</p>
          <div className={classes.Arrow}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10.16 16.36"
              style={{ transform: `rotate3d(0, 1, 0, ${transX === 0 ? 0 : -180}deg)` }}
            >
              {/* <title>Asset 3</title> */}
              <g id="Layer_2" data-name="Layer 2">
                <g id="Layer_1-2" data-name="Layer 1">
                  <polygon points="1.36 16.36 0 14.89 7.22 8.18 0 1.46 1.36 0 10.16 8.18 1.36 16.36"/>
                </g>
              </g>
            </svg>
          </div>
        </button>


      </div>

      {sideTexts}

      <ScrollInfo small={isMobile} color="#090909" 
          clicked={transX > 50 ? ()=> setTransX(0) : null}
        >
          {transX < 50 ? "Scroll down" : "Go back to main page"}
        </ScrollInfo>

    </div>
  );
}

export default Home;